import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Icon from "../elements/icon";
import Checkbox from "./checkbox";
import KeyPressManager from "../../utils/keypress-manager";

const ListboxMultiselectItem = ({ option, onClick, isSelected = false }) => {
  const { label, icon, disabled } = option;

  const handleClick = e => {
    if (disabled) return;
    const isShiftKey = !!e.shiftKey;
    onClick(option, isShiftKey, isSelected);
  };

  return (
    <KeyPressManager
      component="li"
      onEnter={handleClick}
      onSpace={handleClick}
      className={classNames("et-listbox--item", {
        "et-listbox--item-selected": isSelected,
        "et-listbox--item-disabled": disabled,
      })}
      onClick={handleClick}
      role="option"
      aria-selected={isSelected}
    >
      <div className="et-listbox--item-checkbox">
        <Checkbox checked={isSelected} label={label} disabled={disabled} />
        <div>{label}</div>
      </div>

      {icon && (
        <div className="et-listbox--item-icon">
          <Icon icon={icon} />
        </div>
      )}
    </KeyPressManager>
  );
};

ListboxMultiselectItem.propTypes = {
  option: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  isSelected: PropTypes.bool,
};

export default ListboxMultiselectItem;
